export default {"src":"/_next/static/image/src/images/about/icons/tiktok.95d93cd87ba99606e7f2b8bca5d12611.svg","height":24,"width":25};